import React, { useState } from "react";
import { useAuth } from "../lib/auth";
import { Navigate } from "react-router-dom";

export default function Login() {
  const { user, login, error } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  // McCain tiers land on their own dashboard; everyone else lands on /.
  if (user) {
    const isMcCain = ["mccain", "mccain_external", "mccain_supervisor", "mccain_management"].includes(user.role);
    return <Navigate to={isMcCain ? "/mccain" : "/"} replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    await login(email, password);
    setBusy(false);
  };

  const fill = (e, p) => {
    setEmail(e);
    setPassword(p);
  };

  return (
    <div className="auth-shell" data-testid="login-page">
      <aside className="auth-side">
        <div>
          <img src="/brand/newell-logo-admin.png" alt="Newell Scaffolding" data-testid="login-logo" style={{ height: 58, marginBottom: 16, filter: "drop-shadow(0 4px 12px rgba(0,0,0,0.4))" }} />
          <div style={{ color: "#ff5a00", fontFamily: "Chivo", fontWeight: 900, fontSize: 12, letterSpacing: "0.18em" }}>
            McCAIN WHITTLESEY · RFQ-WHIT-SCAF-2026
          </div>
          <div style={{ marginTop: 8, fontFamily: "Chivo", fontWeight: 900, fontSize: 38, lineHeight: 1.05, letterSpacing: "-0.03em" }}>
            OPERATIONS<br />CONSOLE
          </div>
          <div className="mono" style={{ marginTop: 16, opacity: 0.7 }}>
            v1.0 · field-ops + compliance evidence
          </div>
        </div>
        <div style={{ borderLeft: "3px solid #ff5a00", paddingLeft: 16 }}>
          <div style={{ fontFamily: "Chivo", fontWeight: 700, fontSize: 18 }}>
            The evidence trail that wins the contract.
          </div>
          <div className="mono" style={{ opacity: 0.6, marginTop: 6 }}>
            Timestamped handovers · GPS · live inspection register · KPI dashboard
          </div>
        </div>
      </aside>

      <main style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "2rem" }}>
        <div style={{ width: "100%", maxWidth: 420 }}>
          <img src="/brand/newell-logo-admin.png" alt="Newell Scaffolding" style={{ height: 42, marginBottom: 20 }} data-testid="login-logo-form" />
          <h1 style={{ fontSize: 28, fontWeight: 900, margin: 0 }}>Sign in</h1>
          <p style={{ color: "#64748b", marginTop: 6, marginBottom: 28 }}>
            Operations console — authorised personnel only.
          </p>

          <form onSubmit={submit}>
            <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#475569", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 6 }}>
              Email
            </label>
            <input
              data-testid="login-email"
              className="input-base"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
              required
            />
            <label style={{ display: "block", fontSize: 12, fontWeight: 600, color: "#475569", textTransform: "uppercase", letterSpacing: "0.06em", marginTop: 16, marginBottom: 6 }}>
              Password
            </label>
            <input
              data-testid="login-password"
              className="input-base"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />

            {error ? (
              <div data-testid="login-error" className="badge badge-red" style={{ marginTop: 16, width: "100%", padding: "8px 12px" }}>
                {error}
              </div>
            ) : null}

            <button
              data-testid="login-submit"
              type="submit"
              className="btn-primary"
              disabled={busy}
              style={{ width: "100%", marginTop: 24, height: 48 }}
            >
              {busy ? "Signing in…" : "Sign in"}
            </button>
          </form>

          <div style={{ marginTop: 28, borderTop: "1px solid #e2e8f0", paddingTop: 16 }}>
            <div style={{ fontSize: 11, fontWeight: 600, color: "#475569", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 8 }}>
              Demo accounts (one-tap fill)
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 6 }}>
              <button data-testid="demo-fill-admin" type="button" className="btn-ghost" style={{ fontSize: 12, padding: "8px 10px", textAlign: "left" }} onClick={() => fill("viktor.nagy@newellscaffolding.co.uk", "NewellAdmin2026!")}>
                <strong>Admin</strong><br /><span style={{ color: "#64748b", fontSize: 10 }}>Viktor Nagy</span>
              </button>
              <button data-testid="demo-fill-cm" type="button" className="btn-ghost" style={{ fontSize: 12, padding: "8px 10px", textAlign: "left" }} onClick={() => fill("gilly@newellscaffolding.co.uk", "Supervisor2026!")}>
                <strong>Contracts Mgr</strong><br /><span style={{ color: "#64748b", fontSize: 10 }}>Gilly</span>
              </button>
              <button data-testid="demo-fill-supervisor" type="button" className="btn-ghost" style={{ fontSize: 12, padding: "8px 10px", textAlign: "left" }} onClick={() => fill("supervisor@newellscaffolding.co.uk", "Supervisor2026!")}>
                <strong>Supervisor</strong><br /><span style={{ color: "#64748b", fontSize: 10 }}>Tom Carney (SSSTS)</span>
              </button>
              <button data-testid="demo-fill-competent" type="button" className="btn-ghost" style={{ fontSize: 12, padding: "8px 10px", textAlign: "left" }} onClick={() => fill("competent@newellscaffolding.co.uk", "Competent2026!")}>
                <strong>Competent Person</strong><br /><span style={{ color: "#64748b", fontSize: 10 }}>Frank Smith (TWC)</span>
              </button>
              <button data-testid="demo-fill-operative-adv" type="button" className="btn-ghost" style={{ fontSize: 12, padding: "8px 10px", textAlign: "left" }} onClick={() => fill("op-advanced@newellscaffolding.co.uk", "Operative2026!")}>
                <strong>Operative · Advanced</strong><br /><span style={{ color: "#64748b", fontSize: 10 }}>James O&apos;Connor · RAMS sign-off</span>
              </button>
              <button data-testid="demo-fill-operative-labourer" type="button" className="btn-ghost" style={{ fontSize: 12, padding: "8px 10px", textAlign: "left" }} onClick={() => fill("op-part1@newellscaffolding.co.uk", "Operative2026!")}>
                <strong>Operative · Part 1</strong><br /><span style={{ color: "#64748b", fontSize: 10 }}>Aiden Walsh</span>
              </button>
              <button data-testid="demo-fill-subbie" type="button" className="btn-ghost" style={{ fontSize: 12, padding: "8px 10px", textAlign: "left" }} onClick={() => fill("subbie.test@newellscaffolding.co.uk", "Subbie2026!")}>
                <strong>Subcontractor</strong><br /><span style={{ color: "#64748b", fontSize: 10 }}>Pat Cassidy (CIS · thin)</span>
              </button>
              <button data-testid="demo-fill-mccain-supervisor" type="button" className="btn-ghost" style={{ fontSize: 12, padding: "8px 10px", textAlign: "left" }} onClick={() => fill("mccain.supervisor@mccain.co.uk", "McCainSup2026!")}>
                <strong>McCain Supervisor</strong><br /><span style={{ color: "#64748b", fontSize: 10 }}>Sam Bell · request callouts</span>
              </button>
              <button data-testid="demo-fill-mccain-management" type="button" className="btn-ghost" style={{ fontSize: 12, padding: "8px 10px", textAlign: "left", gridColumn: "1 / -1" }} onClick={() => fill("mccain.management@mccain.co.uk", "McCainMgmt2026!")}>
                <strong>McCain Management</strong><br /><span style={{ color: "#64748b", fontSize: 10 }}>Lisa Hayes · RAMS approve + rota diary + KPI</span>
              </button>
            </div>
            <div style={{ marginTop: 10, fontSize: 10, color: "#94a3b8", lineHeight: 1.5 }}>
              These quick-fill accounts let you switch role-context for testing. Each maps to a real seeded account in the system.
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
